import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthService} from "@services/auth/auth.service";
import {appRoutingEnum} from "@enums/appRoutingEnum";
import {StatusEnum} from "@enums/statusEnum";
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class ImageGuard implements CanActivate {

  constructor(private auth: AuthService, private router: Router) {

  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.auth.getStatus() === StatusEnum.NO_IMG) {
      return this.router.parseUrl(appRoutingEnum.CHANGE_PHOTO);
    }
    return this.auth.getStatusFromStorage()
      .pipe(map((status): boolean | UrlTree =>
        status !== StatusEnum.NO_IMG ? true : this.router.parseUrl(appRoutingEnum.CHANGE_PHOTO)))
  }

}
